<div class="flex flex-col gap-2">
    <phx-checkbox
        [(ngModel)]="valuesAreDifferent"
        [label]="'custom-entity-column-schema.values-are-different' | translate"
        (inlineChange)="cdRef.detectChanges()"
        (ngModelChange)="onValuesAreDifferentChange($event)"
    />
    @for (option of selectOptions(); track option) {
        <div class="flex justify-items-stretch content-center gap-3">
            <app-phx-input
                class="flex-grow"
                [(ngModel)]="option.label"
                (ngModelChange)="optionChanged(option)"
                [placeholder]="'common.display-value' | translate"
                ngDefaultControl
            />
            @if (valuesAreDifferent()) {
                <app-phx-input
                    class="flex-grow"
                    [(ngModel)]="option.value"
                    [placeholder]="option.label ? option.label : ('common.value' | translate)"
                    (ngModelChange)="updateValue()"
                    ngDefaultControl
                />
            }
            <p-button
                icon="fa-solid fa-x"
                [rounded]="true"
                [text]="true"
                severity="danger"
                size="small"
                (onClick)="deleteOption(option)"
                [disabled]="!option.label || option.label.length == 0"
            />
        </div>
    }
</div>
